export default __webpack_public_path__ + "static/2-6018b91c6063c1486906caa5309e41d4.png";